import { GenericCell } from '../../templates/tables/Cells.js';
import * as con from '../../GlobalConstants.js';
import './GridTable.css';
import '../../templates/tables/Table.css';
import { RefGridStrategyHook } from '../hooks/gridStrategyHooks.js';
import { RefModelParameterHook } from '../hooks/ModelParameterHooks.js';

// =====================================================
// CONSTANTS
// =====================================================

const STEPS_TABLE = [con.STEP_1, con.STEP_2, con.STEP_3, con.STEP_4];

const ROWS_CONFIG = [
  { label: 'Exposición',              constant: con.EXPOSURES,           cellType: con.MONEY,      currency: con.MONEY_USD, condition: null          },
  { label: 'Cob. x escalon spot',     constant: con.COVERAGES_SPOT,      cellType: con.MONEY,      currency: con.MONEY_USD, condition: con.CAN_SPOT   },
  { label: 'Cob. x escalon fwds',     constant: con.COVERAGES_FWD,       cellType: con.MONEY,      currency: con.MONEY_USD, condition: con.CAN_FWDS   },
  { label: 'Cob. x escalon opciones', constant: con.COVERAGES_OPTION,    cellType: con.MONEY,      currency: con.MONEY_USD, condition: con.CAN_OPTIONS},
  { label: 'Cob. acumulada',          constant: con.COVERAGES,           cellType: con.MONEY,      currency: con.MONEY_USD, condition: null          },
  { label: '% Cob Final',             constant: con.COVERAGE_PERCENTAGE, cellType: con.PERCENTAGE, currency: null,          condition: null          },
];

// =====================================================
// COMPONENT
// =====================================================

const GridResults = () => {
  const gridStrategy = RefGridStrategyHook(con.GRID_STRATEGY);
  const canSpot      = RefModelParameterHook(con.CAN_SPOT);
  const canFwds      = RefModelParameterHook(con.CAN_FWDS);
  const canOptions   = RefModelParameterHook(con.CAN_OPTIONS);

  const conditionMap = {
    [con.CAN_SPOT]:    canSpot,
    [con.CAN_FWDS]:    canFwds,
    [con.CAN_OPTIONS]: canOptions,
  };

  const visibleRows = ROWS_CONFIG.filter(row =>
    row.condition === null || conditionMap[row.condition]
  );

  return (
    <table className="nonFixedTable">
      <thead>
        <tr className="header-row">
          <th>ESCALÓN</th>
          {STEPS_TABLE.map((_, i) => <th key={i}>{i + 1}</th>)}
        </tr>
      </thead>
      <tbody>
        {visibleRows.map((row, visibleIndex) => {
          const isEven = visibleIndex % 2 === 1

          return (
            <tr key={row.label} className={isEven ? 'even-row' : 'uneven-row'}>
              <td>
                <GenericCell
                  evenRow={isEven}
                  cellType={con.TEXT}
                  editing={false}
                  value={row.label}
                />
              </td>
              {STEPS_TABLE.map((step) => (
                <td key={step}>
                  <GenericCell
                    evenRow={isEven}
                    cellType={row.cellType}
                    currency={row.currency}
                    editing={false}
                    value={gridStrategy?.[step]?.[row.constant] ?? '-'}
                  />
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default GridResults;